/*
 * @Author: Pedro Kostelec
 * @Date:   2020-05-26 14:06:41
 * @Last Modified by:   Pedro Kostelec
 * @Last Modified time: 2020-06-10 17:04:04
 */

/**
 * Parses the JSON returned by a network request
 *
 * @param  {object} response A response from a network request
 *
 * @return {object}          The parsed JSON, status from the response
 */
export function parseJSON(response) {
	return new Promise((resolve, reject) => {
		response.clone().text().then((text) => {
			// Handles case where no response body
			if (text) {
				// TODO: check for blank response
				response.clone().json().then((json) =>
					resolve({
						status: response.status,
						ok: response.ok,
						format: 'json',
						json,
					})
				).catch((error) => {
					// Assume's its not valid json, respond with text
					resolve({
						status: response.status,
						ok: response.ok,
						format: 'text',
						text,
					});
				})
			} else {
				resolve({
					status: response.status,
					ok: response.ok,
					format: 'text',
					text,
				});
			}
		});
	});
}